const { getElement, getElements, translateString } = window.BAO.Utils

class LoyaltyRedeemPoints extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.hasBeenSeen = false

    if (this.els.discount) {
      this.setDiscountSizes()
      this.setActiveDiscounts()
    }

    document.addEventListener('swell:setup', () => {
      setTimeout(() => {
        if (this.els.discount) {
          this.setDiscountSizes()
          this.setActiveDiscounts()
        }
        if (this.hasAttribute('toggle-redeem-button')) {
          this.setRedeemButtonVisibility()
          this.observeWidgetMutations()
          this.observeMobileIntersection()
        }
      }, 1000) // Wait for the widget to load
    })
  }

  setupListeners () {
    super.setupListeners()

    document.addEventListener('swell:setup', () => {
      if (window.swellAPI) {
        this.customerDetails = window.swellAPI.getCustomerDetails()

        this.style.setProperty(
          '--RedeemPoints_Progress',
          this.customerDetails.pointsBalance,
        )
      }
    })

    if (this.externalEls['redeem-proxy']) {
      this.listeners.add(
        this.externalEls['redeem-proxy'].element,
        'click',
        this.modalOpen.bind(this),
      )
    }

    if (this.externalEls.submit) {
      this.listeners.add(
        this.externalEls.submit.element,
        'click',
        this.handleRedeemProxyClick.bind(this),
      )
    }

    this.listeners.add(
      this.externalEls['redeem-select'].element,
      'change',
      this.handleSelectChange.bind(this),
    )

    this.externalEls.copy_attribute.elements.forEach(icon => {
      icon.addEventListener('click', () => {
        const text = icon.getAttribute('data-clipboard-text')
        navigator.clipboard.writeText(text).then(() => {
          icon.classList.add('ll-Modal_ItemCopyIcon-copied')
          setTimeout(() => {
            icon.classList.remove('ll-Modal_ItemCopyIcon-copied')
          }, 2000)
        })
      })
    })
  }

  observeWidgetMutations () {
    const observer = new MutationObserver(() => {
      this.setRedeemButtonVisibility()
    })

    observer.observe(this.els.widget.element, {
      childList: true,
      subtree: true,
    })
  }

  observeMobileIntersection () {
    // Don't run function if a medium breakpoint or larger
    if (window.BAO.MediaBreakpoints.isMd) return

    const observer = new IntersectionObserver(entries => {
      const isVisible = entries[0].isIntersecting
      const ratio = Math.round(entries[0].intersectionRatio * 100)
      const sectionOffset =
        document.querySelector('#ll-redeem-points').offsetTop - 85
      if (isVisible) {
        if (ratio > 50) return
        window.scrollTo({
          top: sectionOffset,
          behavior: 'smooth',
        })

        observer.disconnect()
      }
    })

    observer.observe(getElement('.ll-RedeemPoints', { context: document }))
  }

  handleSelectChange () {
    const selectedOption = this.externalEls[
      'redeem-select'
    ].element.value.trim()
    const redeemButton = this.externalEls['redeem-proxy'].element
    const translatedString = translateString(
      this.translations.redeem_translation,
      {
        value: selectedOption,
      },
    )

    redeemButton.disabled = false
    // Set the text of the redeem button
    redeemButton.innerText = translatedString
  }

  modalOpen () {
    const redeemDiscountButtons = this.availableRedeemDiscountButtons
    const selectedOptionValue = this.externalEls['redeem-select'].element.value
    const selectedOption = getElements('option', {
      context: this.externalEls['redeem-select'].element,
    }).find(el => el.value === selectedOptionValue)

    if (redeemDiscountButtons.length === 0) {
      return
    }

    this.externalEls.modal_step.elements.forEach(el => {
      el.ariaHidden = parseInt(el.dataset.step) !== 1
    })

    this.externalEls.modal_title.element.innerText = selectedOptionValue.trim()
    this.externalEls.modal_text.element.innerText =
      selectedOption.dataset.points
  }

  handleRedeemProxyClick () {
    const redeemDiscountButtons = this.availableRedeemDiscountButtons
    const selectedOption = this.externalEls['redeem-select'].element.value
    if (redeemDiscountButtons.length === 0) {
      return
    }

    const buttonToClick = redeemDiscountButtons.find(button => {
      const label = button.parentNode.querySelector(
        '.yotpo-redemption-option-reward',
      ).innerText

      return label === selectedOption
    })

    const parentEl = buttonToClick.parentNode
    buttonToClick.click()

    setTimeout(() => {
      const buttonToClickConfirm = parentEl.querySelector(
        '.yotpo-redemption-confirmation-option-confirm-btn',
      )

      if (buttonToClickConfirm) {
        buttonToClickConfirm.click()
      }

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('loyalty:update'))
      }, 3000)
    }, 500)
  }

  setRedeemButtonVisibility () {
    const isVisible = this.availableRedeemDiscountButtons.length > 0
    const hasCodes = this.currentCodes.length > 0

    this.externalEls['redeem-proxy'].element.setAttribute(
      'aria-hidden',
      !isVisible,
    )

    this.externalEls['redeem-footer'].element.setAttribute(
      'aria-hidden',
      !isVisible,
    )

    // Set the text of the redeem button
    this.externalEls[
      'redeem-proxy'
    ].element.innerText = this.selectionTranslation

    this.externalEls['redeem-proxy'].element.disabled = true

    // If there are redeemable discounts, populate the select
    if (isVisible) {
      this.populateSelect()
    }

    if (hasCodes) {
      this.currentCodes.forEach(code => {
        const label = code.innerText
        const title = code
          .closest('.yotpo-redemption-option-container')
          .querySelector('.yotpo-redemption-option-reward')
          .innerText.trim()

        if (title === this.externalEls.modal_title.element.innerHTML) {
          this.externalEls.copy_text.element.innerText = label.trim()
          this.externalEls.copy_attribute.element.setAttribute(
            'data-clipboard-text',
            label.trim(),
          )

          this.externalEls.modal_step.elements.forEach(el => {
            el.ariaHidden = parseInt(el.dataset.step) !== 2
          })
        }
      })
    }
  }

  populateSelect () {
    // Default option
    const defaultOption = `<option value="" disabled selected>${this.selectRewardTranslation}</option>`
    // Create options
    const options = this.availableRedeemDiscountButtons.map(button => {
      const label = button.parentNode.parentNode.querySelector(
        '.yotpo-redemption-option-reward',
      ).innerText
      const cost = button.parentNode.parentNode
        .querySelector('.yotpo-redemption-option-cost')
        .innerText.trim()

      return `<option value="${label}" data-points="${cost}">${label}</option>`
    })
    // Add default option to the beginning of the array
    options.unshift(defaultOption)
    // Set the options
    this.externalEls['redeem-select'].element.innerHTML = options.join('')
  }

  setActiveDiscounts () {
    this.els.discount.elements.forEach(discount => {
      const pointsForDiscount = Number(discount.dataset.requiredPoints)
      const state =
        pointsForDiscount > this.currentPoints ? 'inactive' : 'active'

      discount.dataset.state = state
    })
  }

  setDiscountSizes () {
    const discountSizes = this.els.discount.elements.map(discount => {
      return Math.ceil(discount.getBoundingClientRect().width)
    })

    const maxDiscountSize = Math.max(...discountSizes)
    this.style.setProperty('--RedeemPoints_ItemSize', `${maxDiscountSize}px`)
  }

  get currentPoints () {
    return Number(this.style.getPropertyValue('--RedeemPoints_Progress'))
  }

  get translations () {
    return JSON.parse(this.dataset.translations)
  }

  get selectionTranslation () {
    return this.translations.selection_translation
  }

  get selectRewardTranslation () {
    return this.translations.select_reward_translation
  }

  get redeemDiscountButtons () {
    /** @type {HTMLButtonElement[]} */
    const buttons = getElements('.yotpo-redemption-option-redeem-button', {
      context: this.els.widget.element,
    })

    return buttons
  }

  get availableRedeemDiscountButtons () {
    return this.redeemDiscountButtons.filter(
      button => button.disabled === false,
    )
  }

  get currentCodes () {
    /** @type {HTMLButtonElement[]} */
    const buttons = getElements('.yotpo-copy-code-content', {
      context: this.els.widget.element,
    })

    return buttons
  }

  set customerDetails (value) {
    this._customerDetails = value
  }

  get customerDetails () {
    return this._customerDetails
  }
}

if (!customElements.get('loyalty-redeem-points')) {
  customElements.define('loyalty-redeem-points', LoyaltyRedeemPoints)
}
